import { render } from "./YachtHulls.vue?vue&type=template&id=45eef9e5&scoped=true"
import script from "./YachtHulls.vue?vue&type=script&lang=js"
export * from "./YachtHulls.vue?vue&type=script&lang=js"

import "./YachtHulls.vue?vue&type=style&index=0&id=45eef9e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45eef9e5"]])

export default __exports__